import React, { useState } from 'react';
import './case.scss';
import {getDateBasedOnDeviceLocale} from "../libs/utils";
import InformationBubble from "../components/InformationBubbleComp";

const TextBubble = ({ message, out = false, time }) => {
    const backgroundColor = out ? '#493AEB' : '#E6E9FF';
    const textColor = out ? '#FFFFFF' : '#707070';
    const hourColor = out ? '#E6E9FF' : '#493AEB';
    const hours = getDateBasedOnDeviceLocale(time);
    // const hours = moment(time).format('MMM Do YYYY, h:mm a');
    return (
        <div
            style={{
                flexDirection: out ? 'row-reverse' : 'row',
                display: 'flex',
                paddingTop: 15,
                paddingRight: 12,
            }}>
            <div
                style={{
                    padding: 16,
                    backgroundColor: backgroundColor,
                    maxWidth: '80%',
                    borderRadius: 8,
                    color: textColor,
                    fontSize: 15,
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                <span>{message}</span>
                <span
                    style={{
                        fontSize: '10px',
                        color: hourColor,
                        marginTop: 10,
                    }}>
                    {hours}
                </span>
            </div>
        </div>
    );
};

/**
 * Opens the live chat widget and optionally executes a callback function when the chat is closed.
 *
 * @function
 * @async
 * @param {function} [onClose] - Optional callback function to execute when the live chat is closed.
 */
const openLiveChat = async (onClose) => {
    if(onClose) onClose();
    // eslint-disable-next-line no-undef
    LiveChatWidget.call('maximize');
}

const Attachment = ({ uri, out }) => {
    let backdrop;
    let imageContainer;
    let image;

    const doSomething = () => {
        if (backdrop.classList.contains('zoom')) {
            backdrop.classList.remove('zoom');
            imageContainer.classList.remove('zoom');
            image.classList.remove('glow');
        } else {
            backdrop.classList.add('zoom');
            imageContainer.classList.add('zoom');
            image.classList.add('glow');
        }
    };

    return (
        <div
            style={{
                flexDirection: out ? 'row-reverse' : 'row',
                display: 'flex',
                paddingTop: 15,
            }}>
            <div
                ref={(e) => (backdrop = e)}
                onClick={doSomething}
                className="Case-event-attachment-backdrop"></div>
            <div
                ref={(e) => (imageContainer = e)}
                onClick={doSomething}
                className="Case-event-attachment-container">
                <img
                    ref={(e) => (image = e)}
                    className="Case-event-attachment"
                    alt={'uploaded attachment'}
                    src={uri}></img>
            </div>
        </div>
    );
};

const CaseEventAttachments = ({ data, out }) => {
    if (!data || !Array.isArray(data)) {
        return null;
    }
    return data
        .map((event, idx) => {
            return (
                <Attachment
                    key={`interactionEventAttachment${idx}`}
                    uri={event.href}
                    out={out}
                />
            );
        })
        .reverse();
};

const CaseEvents = ({ caseInfo, data, onClose }) => {
    if (!data || !Array.isArray(data)) {
        return (
            <InformationBubble
                key={`interactionEvent-01`}
                supportMessage={'Once you submit your request, a support agent will be assigned to your case and reach out to you within a few hours.'}
                support={true}
                overrideSupportStyle={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderWidth: 1,
                    borderStyle: 'solid',
                    marginTop: 25,
                }}
            />
        );
    }

    const workingData = JSON.parse(JSON.stringify(data));
    // if no admin, explain to user
    if (!caseInfo.admin) {
        workingData.push({
            message:
                'A support agent will be assigned to your case within a few hours. We will notify you when they begin working on your case.',
            by: 'INFORMATION',
        });
    } else {
        if (caseInfo.state === 1 && workingData[0].by === 'RECIPIENT') {
            workingData.push({
                message:
                    'A support agent is handling your request and will reply as soon as possible.',
                by: 'INFORMATION',
            });
        }
    }
    if (caseInfo.state > 1) {
        workingData.push({
            message: '\n\n---- Case closed ----\n\n',
            by: 'INFORMATION',
        });

        workingData.push({
            message: '\n Need more help? \n',
            by: 'INFORMATION',
            bubbleType: 'SUPPORT',
            onClose: onClose,
        });
    }
    return workingData.map((event, idx) => {
        const out = event.by === 'RECIPIENT';
        const information = event.by === 'INFORMATION';
        if (information) {
            if (event.bubbleType && event.bubbleType === 'SUPPORT') {
                return (
                    <InformationBubble
                        key={`interactionEvent${idx}`}
                        supportActionText={event.message}
                        support={event.bubbleType && event.bubbleType === 'SUPPORT'}
                        onActionClick={() => openLiveChat(event.onClose)}
                    />
                );
            } else {
                return (
                    <InformationBubble
                        key={`interactionEvent${idx}`}
                        message={event.message}
                        support={event.bubbleType && event.bubbleType === 'SUPPORT'}
                        onActionClick={() => openLiveChat(event.onClose)}
                    />
                );
            }
        }
        return (
            <span key={`interactionEvent${idx}`}>
                <TextBubble
                    // key={`interactionEvent${idx}`}
                    out={out}
                    information={information}
                    message={event.message}
                    time={event.moment}
                />
                {event.attachments ? (
                    <CaseEventAttachments data={event.attachments} out={out} />
                ) : null}
            </span>
        );
    });
};

const CaseHelpOptions = ({ onClose, onCase, status, onChatPress, traveller, onGoToSettings }) => {
    const data = [
        status && ['DELIVERED', 'REVIEWED'].indexOf(status) >= 0 ? (
        {
            title: 'My parcel is damaged',
            type: 'damage',
        }) : null,

        status && ['DELIVERED', 'REVIEWED'].indexOf(status) >= 0 ? (
        {
            title: 'My order has not arrived',
            type: 'delayed',
        }) : null,
        status && ['DELIVERED', 'REVIEWED', 'CANCELLED'].indexOf(status) < 0 ? (
        {
            title: 'Update delivery preferences',
            action: () => {
                // Close this widget
                if (onClose && onChatPress && status && onGoToSettings) {
                    onClose();
                    onGoToSettings();
                }
            },
        } ) : null,
        status && ['DELIVERED', 'REVIEWED', 'IN_STORE', 'RETURNED', 'TO_RETURN', 'CANCELLED'].indexOf(status) < 0 && traveller !== null ? (
        {
            title: 'Chat with the Flyper',
            action: () => {
                // Close this widget
                if (onClose && onChatPress && status) {
                    onClose();
                    onChatPress();
                }
            },
        } ) : null,
        {
            title: 'Chat with support',
            action: () => {
                // Close this widget
                if (onClose) {
                    onClose();
                    // eslint-disable-next-line no-undef
                    LiveChatWidget.call('maximize');
                }
            },
        },
    ];
    if (!data || !Array.isArray(data)) {
        return null;
    }
    return data.map((event, idx) => {
        if (event) {
            // const out = event.from === myId;
            const onOption = () => {
                if (event.action) {
                    event.action();
                } else if (onCase) {
                    onCase(event);
                }
            };

            return (
                <div
                    key={`chatEvent${idx}`}
                    onClick={event.action || onOption}
                    style={{
                        color: '#707070',
                        paddingTop: 20,
                        paddingBottom: 20,
                        paddingRight: 5,
                        paddingLeft: 5,
                        fontSize: 17,
                        borderBottomWidth: 1,
                        borderBottomStyle: 'solid',
                        borderColor: '#C0C0C0',
                        cursor: 'pointer',
                    }}>
                    {event.title}
                </div>
            );
        }
        return null;
    });
};

const CaseBoxTitle = ({ openCaseInfo }) => {
    const getStateText = ({ state }) => {
        switch (state) {
            case 2: // CANCELLED
                return 'Solved';
            case 3: // CLOSED
                return 'Closed';
            case 4: // SOLVED
                return 'Cancelled';
            case 1: // ACTIVE
            default:
                return null;
        }
    };

    let type;
    switch (openCaseInfo.type) {
        case 'damage':
            type = 'Damaged items';
            break;
        case 'lost':
            type = 'Lost items';
            break;
        case 'delayed':
            type = 'Delayed';
            break;
        default:
            type = 'Other issues';
    }
    return (
        <div
            className="Case-box-title"
            style={{
                flexDirection: 'row',
                display: 'inline-flex',
                fontSize: 10,
            }}>
            <div
                style={{
                    flex: 1,
                    flexDirection: 'column',
                }}>
                <div style={{ fontSize: 20 }}>Support</div>
                <div style={{ fontSize: 15 }}>{getStateText(openCaseInfo)}</div>
            </div>
            <div
                style={{
                    flex: 1,
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    textAlign: 'right',
                    fontSize: 13,
                    alignSelf: 'flex-end',
                    marginRight: 20,
                }}>
                <div>Case {openCaseInfo.number}</div>
                <div>{type}</div>
            </div>
        </div>
    );
};

const BoxTitle = ({ title, style, onBack }) => {
    return (
        <div className="Case-box-title" style={{ flexDirection: 'row' }}>
            {onBack ? (
                <span
                    onClick={onBack}
                    className="Icon Icon-back-arrow"
                    style={{
                        cursor: onBack ? 'pointer' : 'auto',
                        height: 23,
                        filter:
                            'invert(42%) sepia(44%) saturate(11%) hue-rotate(13deg) brightness(95%) contrast(96%)',
                    }} />
            ) : null}
            {title}
        </div>
    );
};

const CaseOptionContent = ({ onClose, onCase, status, onChatPress, traveller, onGoToSettings  }) => {
    return (
        <>
            <BoxTitle title={'How can we help you?'} onBack={onClose} />
            <div className="Case-box-content">
                <div
                    style={{
                        display: 'flex',
                        maxFlex: 1,
                        height: 0,
                        flexDirection: 'column',
                        backgroundColor: 'red',
                        marginTop: 5,
                    }}>
                    <CaseHelpOptions onClose={onClose} onCase={onCase} status={status} onChatPress={onChatPress} traveller={traveller} onGoToSettings={onGoToSettings } />
                </div>
            </div>
        </>
    );
};

const CaseInput = ({
    onSend,
    includeData = {},
    sendButton,
    placeholder,
    multiline,
}) => {
    let ref;

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    paddingTop: 10,
                    alignItems: 'center',

                    borderTopStyle: 'solid',
                    borderTopColor: '#C7C7C7',
                    borderTopWidth: 1,

                    marginTop: 10,
                }}>
                <div
                    ref={(e) => (ref = e)}
                    className="Case-input"
                    role="textbox"
                    placeholder={placeholder}
                    contentEditable={true}></div>
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'space-between',
                    marginTop: 10,
                }}>
                <div
                    onClick={() => {
                        if (onSend && ref.innerText !== '') {
                            onSend(
                                Object.assign(includeData, {
                                    message: ref.innerText,
                                }),
                            );
                        }
                        ref.innerText = '';
                    }}
                    style={{
                        color: '#2EB4FF',
                        fontSize: 15,
                        fontWeight: '600',
                        cursor: 'pointer',
                    }}>
                    {sendButton}
                </div>
            </div>
        </>
    );
};

const CaseHistoryContent = ({
    deliveryId,
    openCase,
    onOpenCase,
    onClose,
    openCaseId,
    openCaseInfo,
    openCaseDetail,
}) => {
    if (!openCase && !openCaseId) {
        return null;
    }
    return (
        <>
            {openCaseId && openCaseInfo ? (
                <CaseBoxTitle
                    title={'Support'}
                    openCaseInfo={openCaseInfo}
                    onBack={onClose}
                />
            ) : null}
            {openCase && !openCaseId ? (
                <BoxTitle title={openCase.title} onBack={onClose} />
            ) : null}
            <div className="Case-box-content">
                <div className="Case-box-content-box">
                    <CaseEvents
                        id={'CaseEvents'}
                        caseInfo={openCaseInfo}
                        data={openCaseDetail}
                        onClose={onClose}
                    />
                </div>
            </div>
            {!openCaseId ? (
                <CaseInput
                    onSend={onOpenCase}
                    includeData={{
                        deliveryId,
                        type: openCase.type,
                    }}
                    sendButton={'Send'}
                    placeholder={'Describe your issue...'}
                />
            ) : !openCaseInfo || (openCaseInfo && openCaseInfo.state === 1) ? (
                <CaseInput
                    onSend={onOpenCase}
                    sendButton={'Send'}
                    placeholder={'Write a message...'}
                />
            ) : null}
        </>
    );
};

const Case = ({
    deliveryId,
    traveller,
    onClose,
    onOpenCase,
    openCaseId,
    openCaseInfo,
    openCaseDetail,
    delivery,
    onChatPress,
    onGoToSettings,
}) => {
    const [openCase, setOpenCase] = useState(null);
    return (
        <div className="Case">
            <div className="bg-gradient-blue Case-header">
                <div className="App-header Case-title ">
                    <div onClick={onClose} style={{ paddingLeft: 26 }}>
                        <span
                            className="Icon Icon-back-arrow"
                            style={{ height: 30 }} />
                    </div>
                    <div
                        style={{
                            flex: 1,
                            textAlign: 'center',
                            fontWeight: '700',
                        }}>
                        {openCase
                            ? openCase.title
                            : 'How can we help you?'}
                    </div>
                    <div style={{ width: 50 }}> </div>
                </div>
                <div className="Case-box">
                    <div onClick={onClose} className="Case-box-close-button">
                        <span
                            className={'Icon Icon-close'}
                            style={{
                                height: 'inherit',
                                width: 23,
                                filter:
                                    'invert(52%) sepia(63%) saturate(683%) hue-rotate(168deg) brightness(106%) contrast(101%)',
                            }} />
                    </div>
                    {!openCaseId && !openCase ? (
                        <CaseOptionContent
                            traveller={traveller}
                            onClose={onClose}
                            onCase={(requestedOption) => {
                                setOpenCase(requestedOption);
                            }}
                            status={delivery.status}
                            onChatPress={onChatPress}
                            onGoToSettings={onGoToSettings }
                        />
                    ) : (
                        <CaseHistoryContent
                            deliveryId={deliveryId}
                            openCaseId={openCaseId}
                            openCaseInfo={openCaseInfo}
                            openCaseDetail={openCaseDetail}
                            openCase={openCase}
                            onOpenCase={onOpenCase}
                            onUpdate={setOpenCase}
                            onClose={onClose}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export { Case };
